export const DISPLAY_ERROR_MESSAGE = 'DISPLAY_ERROR_MESSAGE';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const errorMessage = value => ({ type: ERROR_MESSAGE, value });
export const displayErrorMessage = value => ({ type: DISPLAY_ERROR_MESSAGE, value });
export const clearMessage = () => ({ type: CLEAR_MESSAGE });
